import React, { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { HeartHandshake, Loader2 } from "lucide-react";
import { toast } from "sonner";

const f0 = (n) => (typeof n === "number" ? Math.round(n).toLocaleString() : "—");

export const Donate = ({ site, onDone }) => {
  const [amt, setAmt] = useState(10000);
  const [mode, setMode] = useState("wallet");
  const [anon, setAnon] = useState(false);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/social-housing/sites/${site.id}/donate`, { amount_try: amt, mode, anonymous: anon }); toast.success(`${data.tier} · ${f0(data.amount_try)} TRY${data.municipal_match_try ? ` + ${f0(data.municipal_match_try)} municipal match` : ""} · receipt #${data.receipt.token_id}`); onDone(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 bg-[#050A15] border border-white/5 p-3 text-xs" data-testid="donate-form">
      <input data-testid="donate-amount" type="number" min={1} value={amt} onChange={(e) => setAmt(Number(e.target.value))} className="bg-transparent border border-white/10 px-2 py-1.5 w-32 font-mono outline-none focus:border-[#F472B6]" />
      <select data-testid="donate-mode" value={mode} onChange={(e) => setMode(e.target.value)} className="bg-[#050A15] border border-white/10 px-2 py-1.5"><option value="wallet">from TRY wallet (matched 50 %)</option><option value="pledge">pledge (unmatched)</option></select>
      <label className="flex items-center gap-1 text-slate-400"><input type="checkbox" checked={anon} onChange={(e) => setAnon(e.target.checked)} className="accent-[#F472B6]" /> anonymous</label>
      <button data-testid="donate-btn" disabled={busy} onClick={go} className="qs-cta bg-[#F472B6] text-[#050A15] font-semibold px-4 py-1.5 flex items-center gap-1">{busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <HeartHandshake className="h-3.5 w-3.5" />} Donate</button>
    </div>
  );
};
